require('./brokerTechnicalAnalysisSearchView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { formatText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const { connect } = require('react-redux');

const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

const BrokerSearchAction = require('actions/brokerSearch');
const { ContentBox } = require('commonsComponents/contentBox');
const IFRAME_URL = `https://openbank-analisis.webfg.com/buscadorTecnico/${getLanguage()}`;

class BrokerTechnicalAnalysisSearchView extends React.Component {
    render() {
        const breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-technicalAnalysisSearch'),
                url: ''
            }
        ];

        return (
            <div className="broker-technical-analysis-search-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('breadcrumb-technicalAnalysisSearch')}
                    />
                </OKCover>
                <section className="broker-technical-analysis-search-view__body">
                    <div className="row no-outside-gutter">
                        <ContentBox customClassName="broker-technical-analysis-search-view__search">
                            <iframe
                                className="broker-technical-analysis-search-view__iframe"
                                src={IFRAME_URL}
                            />
                        </ContentBox>
                    </div>
                </section>
            </div>
        );
    }
}

BrokerTechnicalAnalysisSearchView.propTypes = {
    handleSearchProduct: PropTypes.func,
    handleSearchReset: PropTypes.func,
    searchProducts: PropTypes.object,
}

module.exports.constructor = BrokerTechnicalAnalysisSearchView;
module.exports.BrokerTechnicalAnalysisSearchView = connect(
    state => ({
        searchProducts: state.brokerSearch,
    }), {
        handleSearchProduct: BrokerSearchAction.searchProduct,
        handleSearchReset: BrokerSearchAction.clearResults
    })(BrokerTechnicalAnalysisSearchView);